import {
  request
} from '@/utils/request.js'

const getHeadPicList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/homepage/head_pic',
    method: 'GET',
    noToken: true,
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getNoticesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/homepage/notices',
    method: 'GET',
    noToken: true,
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getNoticeById = (id, callback, errCallback, finCallback) => {
  request({
    url: `/homepage/notices/${id}`,
    method: 'GET',
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getGamesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/games/games',
    method: 'GET',
    noToken: true,
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPartnersList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/homepage/partners',
    method: 'GET',
    noToken: true,
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

export {
  getHeadPicList,
  getNoticesList,
  getGamesList,
  getPartnersList,
  getNoticeById
}



// WEBPACK FOOTER //
// ./src/servers/homepage.js